import { __read } from 'tslib';
import { useState, useEffect } from 'react';

// 检测是否为移动端设备
var useIsMobile = function useIsMobile() {
  var _a = __read(useState(false), 2),
    isMobile = _a[0],
    setIsMobile = _a[1];
  useEffect(function () {
    var mq = window.matchMedia('(max-width: 767px)');
    setIsMobile(mq.matches);
    var handleResize = function handleResize() {
      setIsMobile(mq.matches);
    };
    mq.addListener(handleResize);
    return function () {
      mq.removeListener(handleResize);
    };
  }, []);
  return isMobile;
};

export { useIsMobile as default };
